module.exports = __webpack_public_path__ + "img/contact-mail.645c25bf.png";